export default "__VITE_ASSET__1b4433dd__"